import React, { PureComponent, PropTypes } from 'react';
import _ from 'underscore';
import _s from 'underscore.string';
import { capitalizeEachWord } from '../util/Etc';

const notBlank = s => !_s.isBlank(s);

export default class CityProvincePostal extends PureComponent {
  static propTypes = {
    city: PropTypes.string,
    province: PropTypes.string,
    postalCode: PropTypes.string
  };

  static defaultProps = {
    city: null,
    province: null,
    postalCode: null
  };

  render() {
    const { city, province, postalCode, ...rest } = this.props;

    const text = _.filter(
      [
        _.filter(
          [
            city ? capitalizeEachWord(city) : null,
            province ? province.toUpperCase() : null
          ],
          notBlank
        ).join(', '),
        postalCode
      ],
      notBlank
    ).join(' ');

    return <span {...rest}>{text}</span>;
  }
}



// WEBPACK FOOTER //
// ./src/js/components/CityProvincePostal.jsx